<script setup>
import { defineAsyncComponent, ref, onMounted, onUnmounted, computed } from "vue";

const Header = defineAsyncComponent(() => import('@/Components/Header/Index.vue'));
const MainSideBar = defineAsyncComponent(() => import('@/Components/MainSideBar/Index.vue'));

const isHomePage = computed(() => {
    return window.location.pathname === '/';
});

const isMobileMenuOpen = ref(false);
const windowWidth = ref(0);

const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
};


const handleResize = () => {
    windowWidth.value = window.innerWidth;
    if (windowWidth.value >= 1024 && isMobileMenuOpen.value) {
        isMobileMenuOpen.value = false;
    }
};

onMounted(() => {
    windowWidth.value = window.innerWidth;
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});
</script>

<template>
 <header class="lg:ml-16 h-16 fixed right-0 left-0 top-0 z-40">
  <Header @toggle-mobile-menu="toggleMobileMenu" />
 </header>

 <div 
    v-if="isMobileMenuOpen" 
    class="fixed inset-0 bg-black/50 z-40 lg:hidden"
    @click="toggleMobileMenu"
 ></div>


 <div class="z-50 fixed right-0 bottom-0 left-0 top-0 w-16 transition-transform duration-300 ease-in-out transform"
    :class="{
        'translate-x-0': isMobileMenuOpen || windowWidth >= 1024,
        '-translate-x-full': !isMobileMenuOpen && windowWidth < 1024
    }"
 >
  <MainSideBar />
 </div>

 <main class="lg:ml-16 mt-16 fixed right-0 left-0 bottom-0 top-0 p-2 overflow-hidden">
  <slot />
 </main>
</template>
